// React 19 – <title>, <meta> a <link> sa automaticky presunú do <head>.
// Žiadna knižnica nie je potrebná.

const SITE_NAME = "Penzión Triferis";
const BASE_URL = process.env.REACT_APP_FRONTEND_URL || "https://triferis.sk";
const DEFAULT_OG = `${BASE_URL}/pictures/og-default.jpg`;

function Seo({ title, description, canonical, ogImage, noIndex = false }) {
  const fullTitle = title ? `${title} | ${SITE_NAME}` : SITE_NAME;
  const canonicalUrl = canonical ? `${BASE_URL}${canonical}` : null;
  const ogImg = ogImage || DEFAULT_OG;

  return (
    <>
      <title>{fullTitle}</title>
      {description && <meta name="description" content={description} />}
      {noIndex && <meta name="robots" content="noindex, nofollow" />}
      {canonicalUrl && <link rel="canonical" href={canonicalUrl} />}

      {/* Open Graph */}
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:title" content={fullTitle} />
      {description && <meta property="og:description" content={description} />}
      {canonicalUrl && <meta property="og:url" content={canonicalUrl} />}
      <meta property="og:image" content={ogImg} />
      <meta property="og:locale" content="sk_SK" />

      {/* Twitter Card */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      {description && <meta name="twitter:description" content={description} />}
      <meta name="twitter:image" content={ogImg} />
    </>
  );
}

export default Seo;
